import { NotificationTypeResponse } from "../../../codegen-api";

/**
 * Types that cannot be muted: a liquidation is never something to miss. The
 * preferences page shows them as "Always on", and the new-notification effect
 * ignores a mute left over from before this rule.
 */
export const ALWAYS_ON_NOTIFICATION_TYPES: readonly NotificationTypeResponse[] = [
  NotificationTypeResponse.LiquidationStarted,
  NotificationTypeResponse.LiquidationCompleted,
];

export const isAlwaysOnNotificationType = (type: NotificationTypeResponse): boolean =>
  ALWAYS_ON_NOTIFICATION_TYPES.includes(type);

export const isNotificationTypeMuted = (
  mutedTypes: readonly NotificationTypeResponse[],
  type: NotificationTypeResponse
): boolean => !isAlwaysOnNotificationType(type) && mutedTypes.includes(type);
